import { render, staticRenderFns } from "./SideBarStyle1.vue?vue&type=template&id=28880fd8&scoped=true&"
import script from "./SideBarStyle1.vue?vue&type=script&lang=js&"
export * from "./SideBarStyle1.vue?vue&type=script&lang=js&"
import style0 from "./SideBarStyle1.vue?vue&type=style&index=0&id=28880fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28880fd8",
  null
  
)

export default component.exports